import { data, Signal, View } from "@lernetz/ts-lib";
import {gateway} from "../../services/gateway";
import template from './App.html';

export class AppView extends View {
    constructor( config? ) {
        super( { template, ...config } );
    }
}

export class AppController {
    scrollEvent: Signal<unknown>;
    modal: any;
    scrollElement: HTMLElement;
    constructor() {
        this.scrollEvent = new Signal();
        gateway.loadGeneralInfos().then(generalInfos => {

            this.modal = {
                'enable': generalInfos.modalEnable,
                'title': generalInfos.modalTitle,
                'description': generalInfos.modalDescription,
                'buttonLink': generalInfos.modalButtonLink,
                'buttonLinkText': generalInfos.modalButtonLinkText,
            };
        });
    }
}
